module.exports = __webpack_public_path__ + "static/media/ehealth_pro_feature_3.6f6557e0.png";